var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMypageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.6921C11.0347 11.6921 10.21 11.3501 9.526 10.6661C8.842 9.98231 8.5 9.15764 8.5 8.19214C8.5 7.22681 8.842 6.40214 9.526 5.71814C10.21 5.03414 11.0347 4.69214 12 4.69214C12.9653 4.69214 13.79 5.03414 14.474 5.71814C15.158 6.40214 15.5 7.22681 15.5 8.19214C15.5 9.15764 15.158 9.98231 14.474 10.6661C13.79 11.3501 12.9653 11.6921 12 11.6921ZM4.5 17.7884V17.0844C4.5 16.5947 4.633 16.1412 4.899 15.7239C5.165 15.3066 5.5205 14.9857 5.9655 14.7614C6.95383 14.2769 7.95092 13.9135 8.95675 13.6711C9.96258 13.4288 10.977 13.3076 12 13.3076C13.023 13.3076 14.0374 13.4288 15.0433 13.6711C16.0491 13.9135 17.0462 14.2769 18.0345 14.7614C18.4795 14.9857 18.835 15.3066 19.101 15.7239C19.367 16.1412 19.5 16.5947 19.5 17.0844V17.7884C19.5 18.2101 19.3523 18.5687 19.0568 18.8644C18.7613 19.1599 18.4026 19.3076 17.9808 19.3076H6.01925C5.59742 19.3076 5.23875 19.1599 4.94325 18.8644C4.64775 18.5687 4.5 18.2101 4.5 17.7884Z",
    fill: "#5950FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypageActive);
export default __webpack_public_path__ + "static/media/mypage_active.4769861cc6044dc9d298960ad87c0bda.svg";
export { ForwardRef as ReactComponent };